<template>
  <div id="history">
    <TopList @setType="setType" :navList="navList"></TopList>
    <Look v-if="type === 0"></Look>
    <Down v-if="type === 1"></Down>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import Look from "./components/look";
import Down from "./components/Down";
export default {
  name: "index",
  components: {
    TopList,
    Look,
    Down,
  },
  data() {
    return {
      navList: ["浏览历史", "下载历史"],
      type: 0,
    };
  },
  methods: {
    setType(i) {
      this.type = i;
      console.log(i);
    },
  },
};
</script>

<style scoped></style>
